// ============================================================
// SCRIPTS.JS — Entry Point
// ============================================================
// Importy bibliotek zewnętrznych
// ============================================================
import '../scss/style.scss';

// ============================================================
// Importy modułów
// ============================================================
import { initTextAnimations } from './modules/text-animations.js';
import { initMobileMenu }     from './modules/mobile-menu.js';
import { initBgVideos }       from './modules/video.js';
//import { initClientsCarousel }from './modules/clients-carousel.js';
import { initFooterAccordion }from './modules/footer-accordion.js';
//import { initScrollVideos }   from './modules/scroll-video.js';
import { initSwiperSliders }  from './modules/swiper-sliders.js';
import { initLightbox }       from './modules/lightbox.js';
import { initContactForms }   from './modules/contact-form.js';
//import { initContactModal }   from './modules/contact-modal.js';
import { initGsapExperience } from './modules/gsap-experience.js';
import { initTabs }           from './modules/tabs.js';
import { initFaqAccordion }   from './modules/faq-accordion.js';
import { initPopupModal }     from './modules/popup-modal.js';

// ============================================================
// DOMContentLoaded
// ============================================================
document.addEventListener('DOMContentLoaded', () => {
    'use strict';

    const header = document.querySelector('.site-header');
    const body   = document.body;

    // Kolejność ważna: menu najpierw (zwraca navbarCollapse potrzebne dla headera)
    const navbarCollapse = initMobileMenu(body);

    initTextAnimations();
    initBgVideos();
    //initClientsCarousel();
    initFooterAccordion();
    //initScrollVideos();
    initSwiperSliders();
    initLightbox();
    initContactForms();
    //initContactModal();
    initGsapExperience({ header, navbarCollapse });
    initTabs();
    initFaqAccordion();
    initPopupModal();
});